// extracted by mini-css-extract-plugin
module.exports = {"terms":"Terms_terms__13M8r","standalone":"Terms_standalone__1n4aa","content":"Terms_content__vfmWr"};